import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import router from './router';
import apolloClient from '@/services/apollo';
import VueApollo from 'vue-apollo';
import App from './App.vue';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "core-js/stable";


import 'cs-components';
import 'cs-components/dist/csuite.css';
import '@/assets/css/design-token.css';
import '@/assets/css/style.css';
import '@/assets/icons/css/styles.css';

Vue.config.productionTip = false;
Vue.use(VueApollo);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueApollo);

Vue.directive('router-link', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context.$router.push(binding.value);
    });
  },
});
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.filter('formatTag', (value) => value.split('-').join(' '));

new Vue({
  apolloProvider,
  router,
  render: (h) => h(App),
}).$mount('#app');
